export const SIGNIN = "SIGNIN";
export const SIGNOUT = "SIGNOUT";
export const GET_CURRENT_SESSION = "GET_CURRENT_SESSION";
